// The build this page came from, for Settings → About and bug reports: set by web/vite.config.ts at build time.
// A page that's been open since before a deploy keeps showing its own build, which is the point.

declare const __BLOOM_BUILD__: { commit: string; dirty: boolean; builtAt: string };

export const BUILD = __BLOOM_BUILD__;

/** "a1b2c3d", or "a1b2c3d (changed)" when built from a tree with changes not yet committed. */
export const buildCommit = `${BUILD.commit}${BUILD.dirty ? " (changed)" : ""}`;

const builtFmt = new Intl.DateTimeFormat(undefined, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
export const builtAt = builtFmt.format(new Date(BUILD.builtAt));

/**
 * The Live pill's hover: "Since Jan 12 12:34 PM", when this build went out (a deploy builds the web app just before
 * it uploads the Worker). The clock is the locale's (12- or 24-hour).
 */
export function liveSince(at: Date | string = BUILD.builtAt, opts: { locale?: string; timeZone?: string } = {}): string {
  const parts = new Intl.DateTimeFormat(opts.locale, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone: opts.timeZone }).formatToParts(new Date(at));
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? "";
  const period = part("dayPeriod");
  return `Since ${part("month")} ${part("day")} ${part("hour")}:${part("minute")}${period ? ` ${period}` : ""}`;
}

/** One line to paste into a bug report. */
export const buildSummary = () => `Bloom web · commit ${buildCommit} · built ${BUILD.builtAt} · ${navigator.userAgent}`;
